const INITIAL_STATE = {
  pontoEmbarqueTipoList: {},
  pontoEmbarqueTipoPesquisa:[],
  pontoEmbarqueTipo: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'EMBARQUETIPO_FETCH':
        return { ...state, pontoEmbarqueTipoList: action.payload }
        case 'EMBARQUETIPO_PESQUISA':
        return { ...state, pontoEmbarqueTipoPesquisa: action.payload }
      case 'EMBARQUETIPO_SET':
        return { ...state, pontoEmbarqueTipo: action.payload }
      default:
        return state
    }
  }